import React from 'react'

const CustomRegionTooltip = ({ active, payload }) => {   
    if (active && payload && payload.length) {
        const payload0= payload[0]!==undefined;
      
      return (
        <div className="custom-normal-tooltip">
          <table className="table">
              <tbody>
                {payload0 &&
                  <tr>
                     
                      <td>{`€ ${payload[0].value}`}</td>
                  </tr>                  
                }              
              </tbody>
          </table>           
        </div>
      );
    }
  
    return null;
  };

  export default CustomRegionTooltip;